import { CustomRegionFilterType } from 'context/entityContext';
import { isArray } from 'lodash';
import { fullStore } from '../redux/store';

const getCountriesFromCustomRegion = (
  customRegionIds: any
): string[] | undefined => {
  const customRegionsFromStore = (fullStore as any).getState().customRegions
    ?.data;
  if (!isArray(customRegionsFromStore)) {
    const countries = isArray(customRegionIds)
      ? customRegionIds.flatMap(
          (id: string) => customRegionsFromStore[id]?.countries
        )
      : customRegionsFromStore[customRegionIds]
      ? [...customRegionsFromStore[customRegionIds]?.countries]
      : [];
    const uniqueCountryIdsSet = new Set(
      countries.filter((item) => item).map((c: any) => c.id)
    );
    return [...uniqueCountryIdsSet];
  }
  return undefined;
};

const validateInExCountries = (territoryList: string[]): string[] => {
  const exCountries = territoryList.filter(
    (territory: string) => territory.indexOf('EX-') === 0
  );

  let filteredCountries = territoryList;

  if (exCountries && exCountries.length) {
    exCountries.forEach((exCountry: string) => {
      const countryWithoutEx = exCountry.slice(-2); // remove EX- from Country ID
      if (territoryList.includes(countryWithoutEx)) {
        filteredCountries = filteredCountries.filter(
          (countryId: string) =>
            countryId !== countryWithoutEx && countryId !== exCountry
        );
      }
    });
  }

  return filteredCountries;
};

const getCountryIds = (
  countryIds: string[] | number[] | string | undefined,
  region: string | undefined,
  customRegion?: CustomRegionFilterType
): string | (string | undefined)[] => {
  const countryIdsArray = Array.isArray(countryIds) ? countryIds : [countryIds];
  const regionArray = Array.isArray(region) ? region : [region];

  const countriesFromCustomRegions = customRegion
    ? getCountriesFromCustomRegion(customRegion)
    : undefined;

  let results: any[] = [];

  if (region) results = [...results, ...regionArray];
  if (countryIds) results = [...results, ...countryIdsArray];
  if (countriesFromCustomRegions)
    results = [...results, ...countriesFromCustomRegions];

  return validateInExCountries(results);
};

export default getCountryIds;
